import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { 
  ERROR_SECTION_I18N_KEYS as MY_I18N_KEYS, 
  ERROR_SECTION_I18N_PREFIX as MY_I18N_PREFIX 
} from '../constants/i18n/ErrorSectioni18nConstants';

import { 
  UPLOAD_FILES_MODAL_I18N_KEYS as UPLOAD_FILE_MODAL_I18N_KEYS, 
  UPLOAD_FILES_MODAL_I18N_PREFIX as UPLOAD_FILE_MODAL_I18N_PREFIX 
} from '../constants/i18n/UploadFilesModali18nConstants';


class ErrorSection extends Component {
  static propTypes = {
    fileValidationErrors: PropTypes.arrayOf(
      PropTypes.shape({
        row: PropTypes.number.isRequired,
        message: PropTypes.string.isRequired,
      })
    ).isRequired
  };

	getMyI18nText(textKey) {
    return t(MY_I18N_PREFIX + "." + textKey);
  }

  getUploadFileModalI18nText(textKey) {
    return t(UPLOAD_FILE_MODAL_I18N_PREFIX + "." + textKey);
  }

  getTotalRowsOrErrorsMessage() {
    const { fileValidationErrors } = this.props;
    
    const isFileEmpty = fileValidationErrors.some(error => error.message.includes(this.getUploadFileModalI18nText(UPLOAD_FILE_MODAL_I18N_KEYS.empty_file_error_message)));

    if (isFileEmpty) {
      return this.getMyI18nText(MY_I18N_KEYS.no_rows_with_relevant_data);
    }

    const missingContentColumn = fileValidationErrors.some(error => error.message.includes(this.getUploadFileModalI18nText(UPLOAD_FILE_MODAL_I18N_KEYS.no_content_column_error_message))); 

    if (missingContentColumn) {
      return this.getMyI18nText(MY_I18N_KEYS.all_rows_have_no_content_column);
    }

    return fileValidationErrors.length;
  }


  render() {
    const { fileValidationErrors } = this.props;

    const totalErrorRowsOrErrorMessage = this.getTotalRowsOrErrorsMessage();
    const isErrorMessage = !Number.isInteger(totalErrorRowsOrErrorMessage);

    return (
      <div className="topic-modal-sub-section">
        <div className="error-section-body">
          <div className='topic-modal-sub-section-header'>
            <span>{this.getMyI18nText(MY_I18N_KEYS.error_title)}</span>
          </div>
          <div className="data-error-row">
            <span className="col-cell">
              <div className="col-remarks">
                <em>{this.getMyI18nText(MY_I18N_KEYS.error_remarks)}</em>
              </div>
            </span>
          </div>
          <div className="data-error-row">
            <div className='col-header'>
              <span>{this.getMyI18nText(MY_I18N_KEYS.total_rows_with_errors)}</span>
            </div>
            <span className={`col-cell ${isErrorMessage ? 'error-text' : ''}`}>{totalErrorRowsOrErrorMessage}</span>
          </div>
          {fileValidationErrors.length > 0 && (
            <div>
              <div className="data-error-row">
                <div className='col-header'>
                  <span>{this.getMyI18nText(MY_I18N_KEYS.location_of_errors)}</span>
                </div>
              </div>
              <div className="error-table">
                <table>
                  <thead>
                    <tr>
                      <th>{this.getMyI18nText(MY_I18N_KEYS.row_header)}</th>
                      <th>{this.getMyI18nText(MY_I18N_KEYS.error_header)}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fileValidationErrors.map((error) => (
                      <tr key={`${error.row}-${error.message}`}>
                        <td>{error.row}</td>
                        <td>{error.message}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ErrorSection;



// WEBPACK FOOTER //
// ./src/features/topics/components/file-upload/ErrorSection.js